import { gql } from "@apollo/client";

export const GET_CONVERSATIONS = gql`
  query Conversations($where: ConversationWhereInput!, $skip: Int, $limit: Int) {
    conversations(where: $where, skip: $skip, limit: $limit) {
      id
      psid
      name
      pageId
      direction
      message
      status
      repliedBy {
        id
        nickname
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_CONVERSATION_THREADS = gql`
  query ConversationThreads($pageId: String!, $skip: Int, $limit: Int) {
    conversationThreads(pageId: $pageId, skip: $skip, limit: $limit) {
      psid
      pageId
      name
      profilePic
      lastMessage
      lastDirection
      lastCreatedAt
      unreadCount
    }
  }
`;
